import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import Table from '../../components/Table/Table';
import DateInput from '../../components/DateInput/DateInput';
import Filter from '../../components/Filter/Filter';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../components/Filter/Filter.styles';
import TextInput from '../../components/TextInput/TextInput';
import Wrapper from '../../components/Wrapper/Wrapper';
import Button from '../../components/Button/Button';
import { useForm } from 'react-hook-form';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../components/SelectOptions/SelectOptions';
import { theme } from '../../styles/theme';
import { useDispatch, useSelector } from 'react-redux';
import { logsFetchAction } from '../../store/fetchActions/logsActions';
import formatCPF from '../../utils/functions/formatCPF';
import { LoadingContainer } from '../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';

import useCallFilter from '../../utils/hooks/useCallFilter';
const {
  mainColor,
  secondaryColor,
  mainColorButtonHover,
  rbmWhite,
  rbmBlack,
  warningColor,
} = theme.colors;

function Logs() {
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState('');
  const [filter, setFilter] = useState({
    search: '',
    DATAINICIAL: '',
    DATAFINAL: '',
    limit: 10,
    page: 1,
  });

  const { paginationLogs, loadingLogs, messageLogs, dataLogs, errorLogs } =
    useSelector((state) => state.logs);

  const { handleSubmit, control } = useForm({});

  useCallFilter(filterData, setFilter, logsFetchAction, 0, 0);

  const filterTable = (data) => setFilterData(data);

  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  useEffect(() => {
    dispatch(logsFetchAction(filter));
  }, [filter.page]);

  const header = [
    {
      id: 'data e hora',
      name: 'DATA/HORA',
      align: 'center',
    },
    { id: 'cpf/cnpj', name: 'CPF/CNPJ', align: 'left' },
    { id: 'nome', name: 'NOME', align: 'left' },
    { id: 'email', name: 'EMAIL', align: 'left' },
    { id: 'ip', name: 'IP', align: 'left' },
    { id: 'id dispositivo', name: 'ID DISPOSITIVO', align: 'left' },
  ];

  const body = dataLogs?.map((log) => {
    return {
      data: [
        {
          info: log.DATAHORA,
          align: 'center',
        },
        {
          info: formatCPF(log.CPFCNPJ),
          align: 'left',
        },
        {
          info: log.NOME,
          align: 'left',
        },

        {
          info: log.EMAIL,
          align: 'left',
        },
        {
          info: log.IP,
          align: 'left',
        },
        {
          info: log.ID_DISPOSITIVO,
          align: 'left',
        },
      ],
    };
  });

  return (
    <Wrapper title="Logs">
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextInput
                label="Nome ou CPF/CNPJ"
                name={'search'}
                width={'38.042vw'}
                margin={'0 0 0 1.389vw'}
                control={control}
                inputProps={{ role: 'filter-text-input' }}
              />
              <DateInput
                label="Data de Início"
                name={'DATAINICIAL'}
                control={control}
              />
              <DateInput
                label="Data Final"
                name={'DATAFINAL'}
                control={control}
              />

              <Button
                backgroundColor={secondaryColor}
                width="12.153vw"
                margin={'0 1.389vw 0 0'}
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={'white'}
                type="submit"
                roleName="button-buscar-logs"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <h5>Resultados por Página</h5>
              <SelectOptions
                control={control}
                options={pagesOptions}
                name={'limit'}
                margin={'0 0 0 1.875vw'}
                initialValue={10}
                initialName={10}
              />
              <h5>Total de Registros: {paginationLogs?.totalResult}</h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingLogs ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingLogs}
            error={errorLogs}
            hasPagination={true}
            filter={filter}
            pagination={paginationLogs}
            setFilter={setFilter}
            errorMessage={messageLogs}
            filterTable={filterTable}
            header={header}
            body={body}
            limit={filter.limit}
          />
        )}
      </div>
    </Wrapper>
  );
}

export default memo(Logs);
